import React from 'react';
import { useLocation } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import './style.scss';

const WhatsAppButton = () => {
    const { pathname } = useLocation();
    if (pathname.startsWith('/admin')) return null; // not for the admin panel

    const phoneNumber = '+919555690946';
    const message = encodeURIComponent('Hello, I would like to schedule a consultation.');
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    return (
        <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsappButton"
            aria-label="Chat on WhatsApp"
        >
            <FaWhatsapp />
            <span className="tooltip">Chat with us</span>
        </a>
    );
};

export default WhatsAppButton;
